import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store';
import { OnboardingKybStatusEnum } from '../enums/onboarding.enum';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, kybStatus } = useAuthStore();

  const dashboardRoutes = [
    '/dashboard',
    '/dashboard/kyb-setup',
    '/dashboard/new-payout',
    '/account',
    '/send/transfers',
    '/send/transaction',
    '/send/settings',
    '/transactions',
    '/settings/kyb-update'
  ];

  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  const status = kybStatus();
  if (status === undefined) {
    return null;
  }

  if (
    status &&
    status === OnboardingKybStatusEnum.Approved &&
    !dashboardRoutes.includes(window.location.pathname)
  ) {
    return <Navigate to="/dashboard" />;
  }

  if (
    status &&
    status === OnboardingKybStatusEnum.Rejected &&
    window.location.pathname !== '/kyb-failed'
  ) {
    return <Navigate to="/kyb-failed" />;
  }

  if (
    status &&
    status !== OnboardingKybStatusEnum.Approved &&
    status !== OnboardingKybStatusEnum.Rejected &&
    window.location.pathname !== '/start-kyb' &&
    window.location.pathname !== '/kyb-session'
  ) {
    return <Navigate to="/start-kyb" />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
